/**
 * The JavaScript code you place here will be processed by esbuild, and the
 * output file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */

import * as bootstrap from 'bootstrap';

import { sticky_nav } from './components/_navbar';
import { mobile_menu_reposition } from './components/_mobile-menu';
import { search_bar_reposition } from './components/_search-bar';
import { back_to_top } from './components/_back-to-top';
import { open_tour_general_modal } from './components/_open-tour-general-modal';
import { jump_links } from './components/_jump-links';
import { mini_gallery_homes } from './components/_mini-gallery-homes';
import { mini_gallery_rentals } from './components/_mini-gallery-rentals';
import { community_submenu } from './components/_community-submenu';
import { schedule_a_tour_buttons } from './components/_schedule-a-tour';
import { salesforce_chat_position } from './components/_salesforce-chat-position';

import { homepage_hero } from './blocks/_homepage-hero';
import { slider_with_big_cards } from './blocks/_slider-with-big-cards';
import { grid_with_mobile_slider } from './blocks/_grid-with-mobile-slider';
import { slider_with_regular_cards } from './blocks/_slider-with-regular-cards';
import { slider_with_tab_navigation } from './blocks/_slider-with-tab-navigation';
import { home_sales_landing_hero } from './blocks/_home-sales-landing-hero';
import { buyers_guide_grid } from './blocks/_buyers-guide-grid';
import { featured_homes_slider } from './blocks/_featured-homes-slider';
import { hubs_hero } from './blocks/_hubs-hero';
import { hubs_expandable_map } from './blocks/_hubs-expandable-map';
import { text_with_masonry_gallery } from './blocks/_text-with-masonry-gallery';
import { slider_with_image_and_text } from './blocks/_slider-with-image-and-text';
import { six_images_masonry } from './blocks/_six-images-masonry';
import { hero_with_title } from './blocks/_hero-with-title';
import { text_with_two_large_images } from './blocks/_text-with-two-large-images';
import { communities_featured_homes_slider } from './blocks/_communities-featured-homes-slider';
import { golf_course_carousel } from './blocks/_golf-course-carousel';
import { golf_course_video } from './blocks/_golf-course-video';
import { hole_cards } from './blocks/_hole-cards';
import { three_images_masonry } from './blocks/_three-images-masonry';
import { communities_rv_hero } from './blocks/_communities-rv-hero';
import { communities_mh_hero } from './blocks/_communities-mh-hero';
import { ways_to_stay_tabs } from './blocks/_ways-to-stay-tabs';
import { video_with_description } from './blocks/_video-with-description';
import { specials_slider } from './blocks/_specials-slider';
import { location_and_contact_anchor } from './blocks/_location-and-contact';

import { facetswp_customs } from './plugins/_facetswp-customs';
import { marketo } from './plugins/_marketo';
import { utm } from './plugins/_utm';

import { single_home, single_home_init_map } from './templates/_single-home';
import { single_rental, single_rental_init_map } from './templates/_single-rental';
import { single_community } from './templates/_single-community';
import { archive_homes } from './templates/_archive-homes';
import { archive_rentals } from './templates/_archive-rentals';
import { archive_communities } from './templates/_archive-communities';
import { page_specials } from './templates/_page-specials';

// Setting up the global window object for the theme
window.COVE = window.COVE || {};

// Settings
window.COVE.maps_marker_icon = {
	path: 'm13.52,31.28c3.21-4.02,10.55-13.77,10.55-19.25C24.06,5.39,18.67,0,12.03,0S0,5.39,0,12.03c0,5.48,7.33,15.23,10.55,19.25.77.96,2.2.96,2.97,0h0Zm-1.49-23.26c2.21,0,4.01,1.8,4.01,4.01s-1.8,4.01-4.01,4.01-4.01-1.8-4.01-4.01,1.8-4.01,4.01-4.01Z',
	scale: 1.15,
	fillColor: '#1F87D3',
	fillOpacity: 1,
	strokeWidth: 1,
	strokeColor: '#FFFFFF',
	anchor: { x: 12, y: 32 },
};

window.COVE.maps_advanced_marker_icon = `
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.07 33" width="25.07" height="33" style="zoom: 1.15">
		<path d="M12.54,32c-.42,0-.82-.19-1.1-.53C8.3,27.55,1,17.86,1,12.53,1,6.17,6.17,1,12.53,1s11.53,5.17,11.54,11.53c0,5.29-7.3,15-10.44,18.94-.27.34-.67.53-1.09.53ZM12.53,8.02c-2.49,0-4.51,2.02-4.51,4.51s2.02,4.51,4.51,4.51,4.51-2.02,4.51-4.51-2.02-4.51-4.51-4.51Z" fill="#1f87d3" fill-rule="evenodd" stroke-width="0"/>
		<path d="M12.53,1.5c6.08,0,11.03,4.95,11.04,11.03,0,5.13-7.23,14.74-10.33,18.62-.24.3-.55.35-.7.35s-.46-.04-.7-.35C5.36,23.08,1.5,16.12,1.5,12.53,1.5,6.45,6.45,1.5,12.53,1.5M12.53,17.54c2.76,0,5.01-2.25,5.01-5.01s-2.25-5.01-5.01-5.01-5.01,2.25-5.01,5.01,2.25,5.01,5.01,5.01M12.53.5C5.89.5.5,5.89.5,12.53c0,5.48,7.33,15.23,10.55,19.25.38.48.93.72,1.48.72s1.1-.24,1.48-.72c3.21-4.02,10.55-13.77,10.55-19.25-.01-6.64-5.4-12.03-12.04-12.03h0ZM12.53,16.54c-2.21,0-4.01-1.8-4.01-4.01s1.8-4.01,4.01-4.01,4.01,1.8,4.01,4.01-1.8,4.01-4.01,4.01h0Z" fill="#fff" stroke-width="0"/>
	</svg>
`;

// Marketo Settings
window.COVE.Marketo = {
	'marketo_domain': '//go.covecommunities.com',
	'munchkin_id': '373-NCW-798'
};

// Components
sticky_nav();
mobile_menu_reposition();
search_bar_reposition();
back_to_top();
open_tour_general_modal();
jump_links();
mini_gallery_homes();
mini_gallery_rentals();
community_submenu();
schedule_a_tour_buttons();
salesforce_chat_position();

// Blocks
homepage_hero();
slider_with_big_cards();
grid_with_mobile_slider();
slider_with_regular_cards();
slider_with_tab_navigation();
home_sales_landing_hero();
buyers_guide_grid();
featured_homes_slider();
hubs_hero();
hubs_expandable_map();
hubs_expandable_map();
text_with_masonry_gallery();
six_images_masonry();
slider_with_image_and_text();
hero_with_title();
text_with_two_large_images();
communities_featured_homes_slider();
golf_course_carousel();
golf_course_video();
hole_cards();
three_images_masonry();
communities_rv_hero();
communities_mh_hero();
ways_to_stay_tabs();
video_with_description();
specials_slider();
location_and_contact_anchor();

// Templates
single_home();
single_home_init_map();
single_rental();
single_rental_init_map();
single_community();
archive_homes();
archive_rentals();
archive_communities();
page_specials();

// Plugins
facetswp_customs();
marketo();
utm();
